import React from 'react'
import CuentaSelected from "../helpers/CuentaSelected";
import Chip from "@material-ui/core/Chip";
import FaceIcon from '@material-ui/icons/Face';
import HomeWorkIcon from '@material-ui/icons/HomeWork';

class ChipUserAccount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            account: {},
        };
    }

    componentDidMount() {
        this.setState({
            account: CuentaSelected.get()
        });
    }

    render() {
        return (
            <span style={{left: '0', position: 'absolute'}}>
                <Chip
                    style={{margin: '10px'}}
                    icon={<HomeWorkIcon/>}
                    label={this.state.account.cuentaCodigo}
                    color="primary"
                    variant="outlined"
                />
                <Chip
                    style={{margin: '10px'}}
                    icon={<FaceIcon/>}
                    label={this.state.account.cuentaCliente}
                    color="primary"
                    variant="outlined"
                />
            </span>
        );
    }
}

export default ChipUserAccount